module.exports = __webpack_public_path__ + "img/logo.64167b4a.svg";